/* packages/volto-castle-theme/src/components/Blocks/HPHero/View.jsx */
import React from 'react';
import HPHero from './HPHero';

const get = (obj, path, fallback = undefined) => {
  if (!obj) return fallback;
  const parts = Array.isArray(path) ? path : String(path).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    if (cur && Object.prototype.hasOwnProperty.call(cur, parts[i])) {
      cur = cur[parts[i]];
    } else {
      return fallback;
    }
  }
  return cur === undefined ? fallback : cur;
};

const firstTruthy = (...vals) => {
  for (let i = 0; i < vals.length; i += 1) {
    if (vals[i]) return vals[i];
  }
  return null;
};

const normalizeSlides = (data) => {
  const slides = Array.isArray(get(data, 'slides', null)) ? data.slides : [];
  if (!slides.length) return [];

  return slides.map((s, idx) => {
    const imageSrc = firstTruthy(
      get(s, 'image.download', null),
      get(s, 'image.url', null),
      get(s, 'image.@id', null),
      get(s, 'image.href', null),
    );

    return {
      id: get(s, 'id', `slide-${idx + 1}`),
      title: get(s, 'title', ''),
      subtitle: get(s, 'subtitle', ''),
      primaryCtaLabel: get(s, 'primaryLabel', 'DOWNLOAD'),
      primaryCtaHref: get(s, 'primaryHref', '#'),
      secondaryCtaLabel: get(s, 'secondaryLabel', 'WATCH TUTORIAL'),
      secondaryCtaHref: get(s, 'secondaryHref', '#'),
      imageSrc,
      imageAlt: firstTruthy(get(s, 'image.alt', null), get(s, 'title', null), 'Slide image'),
    };
  });
};

const View = (props) => {
  const data = props?.data || {};
  const slides = normalizeSlides(data);

  const autoplay = data.autoplay !== false;
  const autoplayMs =
    typeof data.autoplayMs === 'number' && Number.isFinite(data.autoplayMs) ? data.autoplayMs : 6000;

  return <HPHero slides={slides} autoplayMs={autoplay ? autoplayMs : 0} />;
};

export default View;
